import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import Message from '../Message/Message';
import '../../styles/conversation.scss';
import {withExperiments} from 'wix-experiments-react';
import {diffMinutes} from '../../utils/utils';
import get from 'lodash/get';

const MINUTES_THRESHOLD = 10;

class Conversation extends React.Component {

  messageList = null;

  scrollToBottom() {
    if (this.messageList) {
      const scrollHeight = this.messageList.scrollHeight;
      const height = this.messageList.clientHeight;
      const maxScrollTop = scrollHeight - height;
      this.messageList.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
    }
  }

  /* eslint-disable */
  onWheel(ev) {
    var scrollTop = this.messageList.scrollTop,
      scrollHeight = this.messageList.scrollHeight,
      height = this.messageList.clientHeight,
      delta = -ev.deltaY,
      up = delta > 0;

    var prevent = function () {
      ev.stopPropagation();
      ev.preventDefault();
      ev.returnValue = false;
      return false;
    };

    if (!up && -delta > scrollHeight - height - scrollTop) {
      // Scrolling down, but this will take us past the bottom.
      this.messageList.scrollTop = scrollHeight;
      return prevent();
    } else if (up && delta > scrollTop) {
      // Scrolling up, but this will take us past the top.
      this.messageList.scrollTop = 0;
      return prevent();
    }
  }

  /* eslint-enable */

  componentDidMount() {
    this.scrollToBottom();
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  isConsecutiveMessages(msg, nextMsg) {
    return nextMsg &&
      nextMsg.dateTime &&
      msg.direction === nextMsg.direction &&
      diffMinutes(new Date(msg.dateTime), new Date(nextMsg.dateTime)) < MINUTES_THRESHOLD;
  }

  render() {
    const {messages, error, chatSettings} = this.props;
    const shouldShowAvatar = !(get(chatSettings, 'design.selectedImageOption') === '1');
    if (messages.length === 0) {
      return (
        <div className="empty-conversation">
          <span className="icon"/>
          {!error ? <div>{get(chatSettings, 'texts.onlineMessage')}</div> : null}
        </div>
      );
    } else {
      return (
        <div
          ref={div => this.messageList = div}
          onWheel={e => this.onWheel(e)}
          className={`conversation ${shouldShowAvatar ? 'show-avatar' : 'hide-avatar'}`}
          >
          {messages.map((message, index) =>
            <Message
              message={message}
              key={index}
              isLastInSequence={!this.isConsecutiveMessages(message, index < messages.length - 1 ? messages[index + 1] : null)}
              />
          )}
        </div>
      );
    }
  }
}

Conversation.propTypes = {
  messages: PropTypes.array,
  error: PropTypes.bool,
  chatSettings: PropTypes.object
};

function mapStateToProps(state) {
  return {
    chatSettings: state.chatSettings
  };
}

export default withExperiments(connect(mapStateToProps)(Conversation));



// WEBPACK FOOTER //
// ./chat-app/components/Conversation/Conversation.js